<template>
  <div v-if="grade_ranges.length > 0">
    <template v-if="moreThanOneGradeRange && grade_range_group_id == null">
      <div class="range-selector-container">
        <b-form-group
          label-cols-sm="3"
          label-cols-md="2"
          :label="$t('evaluations.gradeRanges.selectedRange')"
          label-for="input-range_group"
          class="mb-3"
        >
          <b-form-select
            id="input-range_group"
            :options="grandeGroupsList"
            v-model="selected_range_group"
            value-field="id"
            text-field="name"
            class="modern-select"
          >
          </b-form-select>
        </b-form-group>
      </div>
    </template>

    <div v-if="gradeRangeList.length > 0" class="ranges-container">
      <!-- Título -->
      <div class="ranges-header">
        <h4 class="mb-4">{{ $t("evaluations.gradeRanges.gradeRanges") }}</h4>
      </div>
      <div class="ranges-legend">
        <div
          v-for="range in gradeRangeList"
          :key="range.id"
          class="range-item"
          :style="{ 'background-color': range.color }"
        >
          <div class="range-details">
            <div class="range-formula">
              <b-badge
                variant="light"
                class="py-2 px-3"
                style="font-size: 14px"
              >
                {{ range.start_grade }}
                <span v-if="range.include_start_grade">&le;</span>
                <span v-else>&lt;</span>
                <span class="mx-1"> {{ range.name.toUpperCase() }}</span>
                <span v-if="range.include_finish_grade">&le;</span>
                <span v-else>&lt;</span>
                {{ range.finish_grade }}
              </b-badge>
            </div>
          </div>
          <!-- <b-td>{{ countGrade(range).length }}</b-td>
          <b-td>
            <template v-if="total_grades.length > 0">
              {{
                ((countGrade(range).length / total_grades.length) * 100)
                  | Round
              }}%
            </template>
            <template v-else>0 %</template>
          </b-td> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
export default {
  name: "GradeTableRanges",
  components: {},
  props: {
    grade_ranges: {
      type: Array,
    },
    grade_ranges_groups: {
      type: Array,
    },
    grade_range_group_id: {
      type: [Number, null],
      default: null,
    },
    // Estructura de la props para que funcione y se pueda reutilizar.
    // [ 1.9, 6, 2.25, 1, 3.45, 1 ]
    // total_grades: {
    //   type: Array,
    // },
  },
  data() {
    return {
      selected_range_group: this.grade_range_group_id,
    };
  },
  computed: {
    // ...mapGetters({}),
    grandeGroupsIds() {
      return [...new Set(this.grade_ranges.map((x) => x.grade_range_group))];
    },
    grandeGroupsList() {
      return this.grade_ranges_groups.filter((x) =>
        this.grandeGroupsIds.includes(x.id)
      );
    },
    moreThanOneGradeRange() {
      if (this.grade_range_group_id != null) return false;
      else {
        if (this.grandeGroupsIds.length > 1) return true;
        else return false;
      }
    },
    gradeRangeList() {
      if (this.grade_range_group_id != null) {
        return this.grade_ranges
          .filter((x) => x.grade_range_group == this.grade_range_group_id)
          .sort(function (a, b) {
            if (a.finish_grade < b.finish_grade) return 1;
            if (a.finish_grade > b.finish_grade) return -1;
            if (a.start_grade < b.start_grade) return 1;
            if (a.start_grade > b.start_grade) return -1;
            return 0;
          });
      } else {
        return this.grade_ranges
          .filter((x) => x.grade_range_group == this.selected_range_group)
          .sort(function (a, b) {
            if (a.finish_grade < b.finish_grade) return 1;
            if (a.finish_grade > b.finish_grade) return -1;
            if (a.start_grade < b.start_grade) return 1;
            if (a.start_grade > b.start_grade) return -1;
            return 0;
          });
      }
    },
  },
  methods: {
    // countGrade(rango) {
    //   return this.total_grades.filter((grade) => {
    //     let incluirNota = false;
    //     const {
    //       start_grade,
    //       finish_grade,
    //       include_start_grade,
    //       include_finish_grade,
    //     } = rango;
    //     if (include_start_grade && include_finish_grade) {
    //       incluirNota = start_grade <= grade && grade <= finish_grade;
    //     } else if (include_start_grade) {
    //       incluirNota = start_grade <= grade && grade < finish_grade;
    //     } else if (include_finish_grade) {
    //       incluirNota = start_grade < grade && grade <= finish_grade;
    //     } else {
    //       incluirNota = start_grade < grade && grade < finish_grade;
    //     }
    //     return incluirNota;
    //   });
    // },
  },
  mounted() {
    if (this.grade_range_group_id == null) {
      this.selected_range_group = this.grandeGroupsIds[0];
    }
  },
  watch: {
    selected_range_group(value) {
      if (value != null) this.$emit("selected_range_group", value);
    },
  },
  created() {},
};
</script>

<style scoped>
/* Contenedor del selector */
.range-selector-container {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
}

.modern-select {
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  font-weight: 500;
}

.modern-select:focus {
  border-color: var(--kl-menu-color);
}

/* Contenedor principal */
.ranges-container {
  background: white;
  padding: 2rem;
}

.ranges-header h4 {
  font-weight: 600;
  margin: 0;
}

/* Badge que solo ocupa el ancho del contenido */
.badge-fit-content {
  display: inline-block;
  width: auto;
}

/* Grid de rangos */
.ranges-legend {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.25rem;
}

/* Item individual de rango */
.range-item {
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: white;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideInLeft 0.4s ease-out backwards;
  border: 1px solid #e9ecef;
}

.range-item:hover {
  transform: translateY(-4px) scale(1.02);
}

.color-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.1) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  pointer-events: none;
}

.range-values-badge {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 0.75rem 0.5rem;
  border-radius: 6px;
}
/* ejemplo 2 */
.range-color-section {
  position: relative;
  width: 150px;
  min-width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.range-details1 {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 1.25rem;
  gap: 0.5rem;
}
.formula-text {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background: #f8f9fa;
  padding: 0.4rem 1.5rem;
  border-radius: 6px;
  color: #495057;
  border: 1px solid #dee2e6;
}
/* ejemplo 2 */
.value-number {
  font-weight: 700;
  color: #2c3e50;
  line-height: 1;
}

.separator {
  font-weight: 600;
  color: #6c757d;
}

/* Detalles del rango */
.range-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 1.25rem;
  gap: 0.5rem;
}

.range-name {
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.range-formula {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px !important;
}

/* Animación */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .ranges-container {
    padding: 1.5rem 1rem;
  }

  .ranges-legend {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .range-values-badge {
    padding: 0.6rem 0.4rem;
  }

  .range-details {
    padding: 0.85rem 1rem;
  }
  /* ejemplo 2 */
  .range-details1 {
    padding: 0.85rem 1rem;
  }
  .formula-text {
    padding: 0.35rem 0.65rem;
  }
  /* ejemplo 2 */
}
</style>